import { History } from 'history';

export function goBack(pathname: string, history: History): void {
  const state = history.location.state as { referer?: string } | undefined;
  if (state?.referer && pathname === state.referer) {
    history.goBack();
    return;
  }
  history.push(pathname);
}

// Bug fix: In some cases, history push do not refresh page after updating URL, this helper force refresh page
export function updateUrlWithForceRefresh(path: string, history: History): void {
  history.push(path);
  history.go(0);
}

// In order to force the refresh of a single page even if your are in this page before.
export function forceRefresh(history: History): void {
  history.push('/');
  history.goBack();
}
